// extracted by mini-css-extract-plugin
export var enews = "index-module--enews--+KUQw";
export var formresponsemessage = "index-module--formresponsemessage--1MMsb";
export var linkhover = "index-module--linkhover--Xx9zm";
export var screenreader = "index-module--screenreader--tUESJ";